module.exports = __webpack_public_path__ + "media/images/landing_pages/personal_accident-13a90c44cafe7746970b72220aecd5be.svg";